const Spinner: React.FC<{ fill?: string }> = (props) => {
  const { fill } = props;
  return (
    <div className='loader-spinner ' title='1'>
      <svg
        version='1.1'
        id='loader-1'
        xmlns='http://www.w3.org/2000/svg'
        x='0px'
        y='0px'
        width='24px'
        height='24px'
        viewBox='0 0 50 50'
      >
        <path
          fill={fill ?? '#000'}
          d='M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z'
        >
          <animateTransform
            attributeType='xml'
            attributeName='transform'
            type='rotate'
            from='0 25 25'
            to='360 25 25'
            dur='0.6s'
            repeatCount='indefinite'
          />
        </path>
        {/* <path
          fill='#212225'
          d='M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z'
        >
          <animateTransform
            attributeType='xml'
            attributeName='transform'
            type='rotate'
            from='0 25 25'
            to='360 25 25'
            dur='0.6s'
            repeatCount='indefinite'
          />
        </path> */}
      </svg>
    </div>
  );
};

export default Spinner;
